import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Table, Card, Spin, Tag } from "antd";
import { fetchPaymentRequest } from "../../../utils/CustomerService/api.js";
import moment from "moment";
import SearchBar from "../../../components/SearchBar/SearchBar.js";

const { Column, ColumnGroup } = Table;

function RequestPayment() {
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);

  const { data: initialData, isLoading: isInitialLoading,refetch } = useQuery({
    queryKey: ["payment",searchText, currentPage, pageSize],
    queryFn: () =>
      fetchPaymentRequest({
        searchText,
        page: currentPage,
        pageSize,
      }),
    keepPreviousData: true,
  });

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) setPageSize(size);
  };

  const dataSource = useMemo(() => {
    return initialData?.results?.map((payment) => ({
      key: payment.customer.id,
      customerName:
        payment.customer?.userAccount?.first_name +
        " " +
        payment.customer?.userAccount?.last_name,
      amount: "1200 ETB",
      timeStamp: moment(payment.time_Stamp).format("MMM D, YYYY h:mm A"),
      status: payment.status,
    }));
  }, [initialData]);

  const handleSearch = (value) => {
    setSearchText(value);
    refetch();
  };

  return (
    <>
      <div className="p-4 bg-white rounded-lg shadow-md dark:bg-gray-900 text-gray-900 dark:text-white">
        <SearchBar onSearch={handleSearch} className="py-2 w-full mb-4" />
        {isInitialLoading ? (
          <Card>
            <Spin /> Loading ...
          </Card>
        ) : (
          <Table
            dataSource={dataSource}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: initialData?.totalCount || 0,
              onChange: handlePageChange,
              showSizeChanger: true,
              responsive: true,
            }}
            scroll={{ x: true }}
            className="responsive-table"
          >
            <ColumnGroup>
              <Column title="Request ID" key="key" dataIndex="key" />
              <Column
                title="Customer Name"
                key="customerName"
                dataIndex="customerName"
              />
              <Column title="Amount" key="amount" dataIndex="amount" />
              <Column
                title="Time Stamp"
                key="timeStamp"
                dataIndex="timeStamp"
              />
              <Column
                title="Status"
                key="status"
                dataIndex="status"
                render={(status) => {
                  let color = "";
                  let label = "";

                  switch (status.toUpperCase()) {
                    case "SUCCESS":
                      color = "bg-green-600 text-white";
                      label = "Completed";
                      break;
                    case "FAILED":
                      color = "bg-red-600 text-white";
                      label = "Failed";
                      break;
                    case "CANCELLED":
                      color = "bg-gray-500 text-white";
                      label = "Cancelled";
                      break;
                    case "PENDING":
                      color = "bg-yellow-500 text-white";
                      label = "Pending";
                      break;
                    default:
                      color = "bg-gray-300 text-black";
                      label = "Unknown";
                  }

                  return (
                    <Tag
                      className={`${color} w-28 flex justify-center px-4 py-1 rounded-md`}
                      key={status}
                    >
                      {label}
                    </Tag>
                  );
                }}
              />
            </ColumnGroup>
          </Table>
        )}
      </div>
    </>
  );
}

export default RequestPayment;
